import { render, staticRenderFns } from "./ResetChangePassword.vue?vue&type=template&id=65f04f2f&scoped=true&"
import script from "./ResetChangePassword.vue?vue&type=script&lang=js&"
export * from "./ResetChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetChangePassword.vue?vue&type=style&index=0&id=65f04f2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f04f2f",
  null
  
)

export default component.exports